<template lang="pug">
    .col-md-6.col-sm-6.col-xs-12.box-parent-public(:id="item.id")
        .box-item-public(@click="onPublicPC")
          img(:src="item.banner[0]" v-if="item.banner && item.banner !== null && item.banner.length > 0")
          img(src="../../../../assets/Obee_Logo_140@2x.png" v-else)
        .item-title(@click="onPublicPC")
          a 
            //- router-link(:to="{ name: 'page_public_detail', params: {id: item.id}}")
            img(:src="item.icon" v-if="item.icon && item.icon.length")
            img(src="../../../../assets/images/faces/ic_AvatarDefault.svg" v-else)
            | {{ item.name }}
        .box-info
          .avatar(@click="publicTeacher(item.user_id)")
            img(:src="item.avatar" v-if="item.avatar && item.avatar !== null && item.avatar.length")
            img(src="../../../../assets/images/faces/ic_AvatarDefault.svg" v-else)
            span.fullname {{item.fullname}}
          .item-info(@click="onPublicPC")
              a
                img(src="../../../../assets/images/faces/ic_khoilop@2x.png")
                span.subjects {{item.subject_name}}
              a
                img(src="../../../../assets/images/faces/ic_thanhvien@2x.png")
                span.grades(v-text="messageText")
          .clearfix
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../../Model/graphqlfront'
import MdNotification from '@/core/components/mdNotification'
export default {
  components: {
    MdNotification
  },
  props: {
    item: Object,
    obj_id: Number
  },
  data() {
    return {
      object_id: this.obj_id,
      isSucess: false,
      message: this.$t('home.comming_soon'),
      messageText: '',
      messageTextOld: '',
      count: 0,
      numerMember: 0,
      memberYou: '',
      member_join: this.$t('home.public.member_join'),
      member_self: this.$t('home.public.member_self'),
      member_you: this.$t('home.public.member_you'),
      member_you_self: this.$t('home.public.member_you_self'),
      member_self_other: this.$t('home.public.member_self_other'),
      member_you_other: this.$t('home.public.member_you_other'),
      member_full: this.$t('home.public.member_full'),
      member_other: this.$t('home.public.member_other')
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    publicTeacher(userID) {
      this.$router.push({name: 'account-view', params: {uid: userID}})
    },
    onPublicPC() {
      window.location.href = this.url(this.item.site_id, this.item.name, this.item.id)
    },
    url(siteID, title, pcID) {
      let url = window.location.origin + '/' + this.$router.resolve({path: '/'}).href + 'landing/' + siteID + '/'
      let seoUrl = url + this.$mycontroller.doSanitizeTitle(title) + '-' + pcID
      return seoUrl
    },
    onLessonSubject(paramSubject) {
      this.$router.push({name: 'page_public', params: {subject_id: paramSubject}})
      this.$parent.onRefreshSubect(paramSubject)
    },
    getScrollTop(element) {
      if (element === window) return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
      return element.scrollTop
    },
    isMobile() {
      if (window.innerWidth < 991) return true
      return false
    },
    formatMemberText() {
      if (this.count === 0 && this.numerMember === 1) {
        this.messageText = this.member_self
      } else if (this.count === 0 && this.numerMember === 2) {
        this.messageText = this.member_you.replace('{0}', this.memberYou)
      } else if (this.count === 0 && this.numerMember === 3) {
        this.messageText = this.member_you_self.replace('{0}', this.memberYou)
      } else if (this.count > 0) {
        if (this.numerMember === 1) {
          this.messageText = this.member_self_other.replace('{0}', this.numberWithCommas(this.count))
        } else if (this.numerMember === 2) {
          this.messageText = this.member_you_other.replace('{0}', this.memberYou).replace('{1}', this.numberWithCommas(this.count))
        } else if (this.numerMember === 3) {
          this.messageText = this.member_full.replace('{0}', this.memberYou).replace('{1}', this.numberWithCommas(this.count))
        } else {
          this.messageText = this.member_other.replace('{0}', this.numberWithCommas(this.count))
        }
      } else {
        this.messageText = this.member_join.replace('{0}', this.numberWithCommas(this.count))
      }
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    async changeText() {
      this.count = this.item.count
      if (!this.$store.getters.isLoggedIn) {
        this.messageText = this.numberWithCommas(this.count) + ' ' + this.$t('home.public.member')
        this.messageTextOld = this.messageText
      } else {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_USER_JOIN_PC),
          fetchPolicy: 'no-cache',
          variables: {
            pc_id: this.object_id,
            user_id: this.$store.getters.user,
            status: 2
          }
        })
        if (data.pc_user && data.pc_user !== undefined && data.pc_user !== null && data.pc_user.length > 0) {
          this.numerMember = 1
          this.count -= 1
        }
        if (data.v_front_pc_join_user_aggregate && data.v_front_pc_join_user_aggregate.aggregate !== undefined && data.v_front_pc_join_user_aggregate.aggregate !== null && data.v_front_pc_join_user_aggregate.aggregate.count > 0) {
          this.numerMember += 2
          let countUser = data.v_front_pc_join_user_aggregate.aggregate.count
          this.memberYou = this.numberWithCommas(countUser)
        }
        this.formatMemberText()
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.changeText()
    }, 100)
  },
  destroyed: function() {
  },
  apollo: {
  }
}
</script>
<style lang="scss">
</style>




// WEBPACK FOOTER //
// Item.vue?183fbdd6